import { render, staticRenderFns } from "./EsgScorecardBlock.vue?vue&type=template&id=459960e2&scoped=true"
import script from "./EsgScorecardBlock.vue?vue&type=script&lang=js"
export * from "./EsgScorecardBlock.vue?vue&type=script&lang=js"
import style0 from "./EsgScorecardBlock.vue?vue&type=style&index=0&id=459960e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459960e2",
  null
  
)

export default component.exports